<!-- drawer -->
<div
  class="fixed mt-[80px] overflow-hidden z-30 bg-gray-900 bg-opacity-25 inset-0 transform ease-in-out"
  (click)="close($event)"
  [ngClass]="{
    'transition-opacity': isOpenMenu,
    'opacity-100': isOpenMenu,
    'translate-x-0': isOpenMenu,
    'transition-all': !isOpenMenu,
    'delay-1500': !isOpenMenu,
    'opacity-0': !isOpenMenu,
    'translate-x-full': !isOpenMenu
  }"
>
  <section
    class="w-full right-0 absolute bg-neutral-06 h-full shadow-xl duration-500 ease-in-out transition-all transform"
    (click)="$event.stopPropagation()"
    [ngClass]="{ 'translate-x-0': isOpenMenu, 'translate-x-full': !isOpenMenu }"
  >
    <article class="px-5 text-neutral-01 text-sm">
      <!-- Mobile utility actions -->
      <div class="-mx-5 mb-3 flex items-center gap-3 bg-secondary-dark-green-2 px-5 py-3 text-xs rounded-b-3xl">
        <a
          (click)="openfDragon()"
          class="flex min-w-0 flex-1 cursor-pointer items-center justify-center rounded-full bg-neutral-06 px-3 py-2 font-semibold
            text-primary"
        >
          <img src="assets/images/logo/fDragon-logo.png" alt="fDragon" class="max-h-5 w-auto" />
        </a>
        <a
          routerLink="{{ '/' + currentLanguage + '/mo-tai-khoan' }}"
          (click)="close($event)"
          class="flex min-w-0 flex-1 cursor-pointer items-center text-sm justify-center whitespace-nowrap rounded-full bg-secondary px-3
            py-2 font-semibold text-neutral-06"
        >
          {{ 'OPEN_ACCOUNT' | translate }}
        </a>
        <div class="group relative shrink-0">
          <button type="button" class="flex h-9 items-center gap-2 rounded-full bg-[#71B949] px-3 text-neutral-06" aria-haspopup="listbox">
            <img *ngIf="currentLanguage === 'vi'" src="assets/svg/ic-vn.svg" alt="ic-vn" width="22" height="14" />
            <img *ngIf="currentLanguage === 'en'" src="assets/svg/ic-en.svg" alt="ic-us" width="22" height="14" />
            <img src="assets/svg/ic-arrow-down-list.svg" />
          </button>
          <div class="group-hover:block w-[72px] dropdown-menu absolute hidden right-0 top-full z-50 pt-1">
            <ul class="rounded-md p-1 bg-neutral-06 overflow-hidden shadow-dropdown-menu">
              <li>
                <a
                  class="p-1 mb-1 rounded-md flex justify-center cursor-pointer hover:bg-neutral-08"
                  [class.bg-neutral-08]="currentLanguage === 'vi'"
                  (click)="changeSiteLanguage('vi')"
                >
                  <img src="assets/svg/ic-vn.svg" alt="ic-vn" width="26" height="18" />
                </a>
              </li>
              <li>
                <a
                  class="p-1 mb-1 rounded-md flex justify-center cursor-pointer hover:bg-neutral-08"
                  [class.bg-neutral-08]="currentLanguage === 'en'"
                  (click)="changeSiteLanguage('en')"
                >
                  <img src="assets/svg/ic-en.svg" alt="ic-en" width="26" height="18" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- AboutUs -->
      <ng-container *ngIf="navAboutUs && navAboutUs.children && navAboutUs.children[0]">
        <div class="flex justify-between border-t-none border-neutral-07 py-3" (click)="expandMenu(0)">
          <p class="font-bold">
            {{ navAboutUs.item.name || 'Về QLQ Rồng Việt' }}
          </p>
          <img [class.rotate-90]="expandMenuId === 0" src="assets/svg/ic-carvet.svg" alt="ic-carvet" width="16" height="16" />
        </div>
        <ng-container *ngIf="navAboutUs.children">
          <ul class="pl-4 bg-neutral-06" *ngIf="expandMenuId === 0">
            <ng-template ngFor let-item [ngForOf]="navAboutUs.children" [ngForTrackBy]="trackByLinkUrl">
              <li
                *ngIf="item.item.showMenu"
                class="flex justify-between menu-item border-b border-neutral-07 last:border-b-0 px-4 py-3 text-neutral-18
                  hover:text-primary hover:font-bold"
              >
                <a
                  class="cursor-pointer"
                  (click)="close($event)"
                  routerLink="{{ '/' + currentLanguage + '/' + navAboutUs.item.linkUrl + '/' + item.item.linkUrl }}"
                >
                  {{ item.item.name }}
                </a>
              </li>
            </ng-template>
          </ul>
        </ng-container>
      </ng-container>

      <!-- Investment Funds  -->
      <ng-container *ngIf="investmentFundsNav && investmentFundsNav.children && investmentFundsNav.children[0]">
        <div class="flex justify-between border-t border-neutral-07 py-3" (click)="expandMenu(1)">
          <p class="font-bold">
            {{ investmentFundsNav.item.name || 'Quản lý quỹ đầu tư' }}
          </p>
          <img [class.rotate-90]="expandMenuId === 1" src="assets/svg/ic-carvet.svg" alt="ic-carvet" width="16" height="16" />
        </div>
        <ng-container *ngIf="investmentFundsNav.children">
          <ul class="pl-4 bg-neutral-06" *ngIf="expandMenuId === 1">
            <ng-template ngFor let-item [ngForOf]="investmentFundsNav.children" [ngForTrackBy]="trackByLinkUrl">
              <li
                *ngIf="item.item.status && item.item.showMenu"
                class="flex justify-between menu-item border-b border-neutral-07 last:border-b-0 px-4 py-3 text-neutral-18
                  hover:text-primary hover:font-bold"
              >
                <a
                  class="cursor-pointer"
                  (click)="close($event)"
                  routerLink="{{ '/' + currentLanguage + '/' + investmentFundsNav.item.linkUrl + '/' + item.item.linkUrl }}"
                >
                  {{ item.item.name }}
                </a>
              </li>
            </ng-template>
          </ul>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="portfolioNav">
        <div
          class="flex justify-between border-t border-neutral-07 py-3"
          (click)="close($event)"
          routerLink="{{ '/' + currentLanguage + '/' + portfolioNav.linkUrl }}"
        >
          <p class="font-bold">{{ portfolioNav.name || 'Quản lý danh mục đầu tư' }}</p>
        </div>
      </ng-container>

      <ng-container *ngIf="advisoryNav">
        <div
          class="flex justify-between border-t border-neutral-07 py-3"
          (click)="close($event)"
          routerLink="{{ '/' + currentLanguage + '/' + advisoryNav.linkUrl }}"
        >
          <p class="font-bold">{{ advisoryNav.name || 'Tư vấn đầu tư' }}</p>
        </div>
      </ng-container>

      <ng-container *ngIf="iDAtHomePage">
        <div class="flex justify-between border-t border-neutral-07 py-3" (click)="expandMenu(4)">
          <p class="font-bold">{{ 'INFORMATION_DISCLOSURE' | translate }}</p>
          <img [class.rotate-90]="expandMenuId === 4" src="assets/svg/ic-carvet.svg" alt="ic-carvet" width="16" height="16" />
        </div>

        <ul class="pl-4 bg-neutral-06" *ngIf="expandMenuId === 4">
          <ng-template ngFor let-item [ngForOf]="iDAtHomePage" [ngForTrackBy]="trackByHomePageItem">
            <li
              *ngIf="checkQuanHeCoDongAboutUs(item)"
              class="flex justify-between menu-item border-b border-neutral-07 last:border-b-0 px-4 py-3 text-neutral-18 hover:text-primary
                hover:font-bold"
            >
              <a
                class="cursor-pointer"
                (click)="close($event)"
                routerLink="{{
                  '/' +
                    currentLanguage +
                    '/' +
                    navAboutUs?.item?.linkUrl +
                    '/' +
                    shareholderRelationsNav?.linkUrl +
                    '/' +
                    catInformationDisclosure?.linkUrl
                }}"
              >
                {{ currentLanguage === 'vi' ? item.name : item?.nameEn }}
              </a>
            </li>
            <li
              *ngIf="!checkQuanHeCoDongAboutUs(item) && checkShowOnMenu(item)"
              class="flex justify-between menu-item border-b border-neutral-07 last:border-b-0 px-4 py-3 text-neutral-18 hover:text-primary
                hover:font-bold"
            >
              <a
                class="cursor-pointer"
                (click)="close($event)"
                routerLink="{{ '/' + currentLanguage + '/' + investmentFundsNav?.item?.linkUrl + '/' + item.linkUrl }}"
              >
                {{ item.name }}
              </a>
            </li>
          </ng-template>
        </ul>
      </ng-container>

      <ng-container *ngIf="knowledgeNav && knowledgeNav.children">
        <div class="flex justify-between border-y border-neutral-07 py-3" (click)="expandMenu(5)">
          <p class="font-bold">{{ knowledgeNav.item.name || 'Kiến thức đầu tư' }}</p>
          <img [class.rotate-90]="expandMenuId === 5" src="assets/svg/ic-carvet.svg" alt="ic-carvet" width="16" height="16" />
        </div>
        <ng-container *ngIf="knowledgeNav.children">
          <ul class="pl-4 bg-neutral-06" *ngIf="expandMenuId === 5">
            <ng-template ngFor let-item [ngForOf]="knowledgeNav.children" [ngForTrackBy]="trackByLinkUrl">
              <li
                *ngIf="item.item.showMenu"
                class="flex justify-between menu-item border-b border-neutral-07 last:border-b-0 px-4 py-3 text-neutral-18
                  hover:text-primary hover:font-bold"
              >
                <a
                  class="cursor-pointer"
                  (click)="close($event)"
                  routerLink="{{ '/' + currentLanguage + '/' + knowledgeNav.item.linkUrl + '/' + item.item.linkUrl }}"
                >
                  {{ item.item.name }}
                </a>
              </li>
            </ng-template>
          </ul>
        </ng-container>
      </ng-container>
    </article>
  </section>
</div>
